import React, { createElement, Component } from 'react';
import PropTypes from 'prop-types';
import isSyntheticEvent from '@insight/toolkit-utils/lib/types/environment/isSyntheticEvent';
import shallowEqual from '@insight/toolkit-utils/lib/helpers/shallowEqual';

import createForm from './createForm';
import { formSubscriptionItems } from './constants';
import { FormContext } from './context';
import renderComponent from './renderComponent';

export const all = formSubscriptionItems.reduce(
  (result, key) => ({
    ...result,
    [key]: true,
  }),
  {}
);

export default class Form extends Component {
  constructor(props) {
    super(props);

    const { children, component, decorators, render, subscription, ...rest } =
      props;
    const config = rest;

    this.mounted = false;
    this.form = createForm(config);
    this.unsubscriptions = [];

    if (this.form) {
      let initialState = {};
      this.form.subscribe((state) => {
        initialState = state;
      }, subscription || all)();
      this.state = { state: initialState };
    }

    if (decorators) {
      decorators.forEach((decorator) => {
        this.unsubscriptions.push(decorator(this.form));
      });
    }

    //if (this.form) {
    //	this.form.pauseValidation()
    //}
  }

  componentDidMount() {
    if (this.form) {
      this.unsubscriptions.push(
        this.form.subscribe(this.notify, this.props.subscription || all)
      );
    }
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const { initialValues } = this.props;
    if (this.form && snapshot) {
      //this.form.resumeValidation()
    }
    if (
      initialValues &&
      !shallowEqual(prevProps.initialValues, initialValues)
    ) {
      this.form.initialize(initialValues);
    }
  }

  componentWillUnmount() {
    this.unsubscriptions.forEach((unsubscribe) => unsubscribe());
  }

  generateSnapshotBeforeUpdate() {
    if (this.form) {
      const resume = !this.form.isValidationPaused();
      this.form.pauseValidation();
      return resume;
    }
    return false;
  }

  notify = (state) => {
    if (this.mounted) {
      this.setState({ state });
    }
    this.mounted = true;
  };

  handleSubmit = (e) => {
    if (e) {
      if (typeof e.preventDefault === 'function') {
        e.preventDefault();
      }
      if (typeof e.stopPropagation === 'function') {
        e.stopPropagation();
      }
    }

    return this.form.submit();
  };

  render() {
    const {
      initialValues,
      mutators,
      onSubmit,
      subscription,
      validate,
      validateOnBlur,
      ...rest
    } = this.props;

    const renderProps = {
      ...(this.state ? this.state.state : {}),
      form: {
        ...this.form,
        reset: (eventOrValues) => {
          if (isSyntheticEvent(eventOrValues)) {
            this.form.reset();
          } else {
            this.form.reset(eventOrValues);
          }
        },
      },
      handleSubmit: this.handleSubmit,
    };
    return createElement(
      FormContext.Provider,
      { value: this.form },
      renderComponent(
        {
          ...rest,
          ...renderProps,
        },
        'Form'
      )
    );
  }
}
